import { Component, Inject, NgZone, OnDestroy, OnInit, ViewChild, ViewChildren,QueryList } from '@angular/core';
import { NgForm } from '@angular/forms';
import {_} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { PerformanceContextService } from '../../services/performance-context.service';

// interfaces
import { Herd, Farm, PerformanceContext } from '../../interfaces/mysynch.interfaces';
import { Invitation,InvitationValidation,UserManagementUser,UserRow,InvitationRow } from './user-management.interfaces';
import { PageTrackerService } from '../../services/page-tracker.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { BroadCastService } from '../../services/broadcast.service';
import { MySynchSelect } from '../../form-controls/mysynch-select/mysynch-select.component';

@Component({
    standalone: false,
    selector: 'user-management',
    templateUrl: '../app/pages/user-management/user-management.view.html',
    styleUrls: ['../app/pages/user-management/user-management.style.css']
    })
export class UserManagement implements OnInit , OnDestroy{

    @ViewChild('adminForm') adminForm: NgForm;
    @ViewChildren(MySynchSelect) dropdowns: QueryList<MySynchSelect>;

    private performanceContext: PerformanceContext | null = null;
    private currentFarm:Farm;
    private currentHerd:Herd;
    private deregTransitionOnStart:any;
    private deregCurrentFarmSubscription:any;
    private deregCurrentHerdSubscription:any;
    
    _:any;
   
    isMobile:boolean = this.deviceDetector.isMobile();
    loading:boolean = true;
   
    farmName:string	= "";
    userRows:UserRow[]	= [];
    invitationRows:InvitationRow[]	= [];
    invitingUsers:boolean = false;

    usersToRemove:any[] = [];
    removeFromAllFarms:boolean = false;
    deleteUsers:boolean = false;
    canDeleteUsers:boolean = false;


    personRoles:any[] = [];
    personTypes:any[] = [];
    personRoleStatuses:any[] = [];
    pendingValue:number = undefined;
    pendingText:string	= undefined;

    mySynchSelectAppendTo:string = 'body';

    isSuperAdmin:boolean = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'));



    constructor(@Inject('MySynchFactory') private MSF:any,
    @Inject('ApiFactory') private api:any,
    @Inject('ViewAuthorizationFactory') private viewAuth:any,
    @Inject('$transitions') private $transitions,
    @Inject(NgZone) private zone:NgZone,
    @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
    @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
    @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
    @Inject(PageTrackerService) private pageTracker:PageTrackerService,
    @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
    @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
    @Inject(BroadCastService) private broadCastService: BroadCastService,
    @Inject(ClientLoggerService) private log:ClientLoggerService
    ){
        this._ = _;

        this.isChanged = this.isChanged.bind(this);

    }

    
    private  newInvitation(): Invitation {
        return {
            firstName:		'',
            lastName:		'',
            email:			'',
            role:			null,
            permissions:	null,
            status:			this._.get(this.mySynchEnumSvc.getMySynchEnumeration('PersonRoleStatus','ACTIVE'),'value'),
            validation: {
                firstName:		true,
                lastName:		true,
                email:			true,
                role:			true,
                permissions:	true,
                status:			true
            } 
        };
    }

    
    private defaultInvitations() {
        return this._.map(this._.range(3), (index) => this.newInvitation());
    }

    private confirmAbilityToDeleteUsers() {
        this.canDeleteUsers = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN')) 
                           || this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'));               
    }

    private buildInvitationRows():void {
        let invitationRows = [];
        let newInvitaions = this.defaultInvitations();
        this._.forEach(newInvitaions, (invitation:Invitation, index) => {
            invitation.role = this._.first(this.personTypes);
            invitation.permissions = this._.first(this.personRoles);
           
            let invitationRow: InvitationRow = {
                id: index,
                invitation: invitation,
                personTypeInitialSelected: invitation.role,
                personTypeSelectConfig: {
                    controlId: 'personType' + index,
                    labelProperty: 'text',
                    labelDisplayField: 'text',
                    valueKeyField: 'value',
                    orderByFields: ['text'],
                    orderByDirections: ['asc'],
                    placeholder: 'Select Role',
                    virtualScroll: false,
                    onChange: (personType:any)=>{
                        invitation.role = personType;
                        if(this.isChanged(invitation)){
                            this.adminForm.form.markAsDirty();
                        }
                    },
                    onAdd: (personType:any)=>{},
                    onOpen: ()=>{
                        
                    },
                    onClose: ()=>{
                        
                    },
                },
                personRoleInitialSelected: invitation.permissions,
                personRoleSelectConfig: {
                    controlId: 'personRole' + index,
                    labelProperty: 'text',
                    labelDisplayField: 'text',
                    valueKeyField: 'value',
                    orderByFields: ['text'],
                    orderByDirections: ['asc'],
                    placeholder: 'Select Permissions',
                    virtualScroll: false,
                    onChange: (personRole:any)=>{
                        invitation.permissions = personRole;
                        if(this.isChanged(invitation)){
                            this.adminForm.form.markAsDirty();
                        }
                    },
                    onAdd: (personRole:any)=>{},
                    onOpen: ()=>{
                        
                    },
                    onClose: ()=>{
                        
                    },
                }
            };
            invitationRows.push(invitationRow);
        });
        this.invitationRows = invitationRows;
    }
        
    private buildInvitationRow():void{
        let newInvitation = this.newInvitation();
        newInvitation.role = this._.first(this.personTypes);
        newInvitation.permissions = this._.first(this.personRoles);
        let invitationRow: InvitationRow = {
            id: this.invitationRows.length,
            invitation: newInvitation,
            personTypeInitialSelected: newInvitation.role,
            personTypeSelectConfig: {
                controlId: 'personType' + this.invitationRows.length,
                labelProperty: 'text',
                labelDisplayField: 'text',
                valueKeyField: 'value',
                orderByFields: ['text'],
                orderByDirections: ['asc'],
                placeholder: 'Select Role',
                virtualScroll: false,
                onChange: (personType:any)=>{
                    invitationRow.invitation.role = personType;
                    if(this.isChanged(invitationRow.invitation)){
                        this.adminForm.form.markAsDirty();
                    }
                },
                onAdd: (personType:any)=>{},
                onOpen: ()=>{
                    
                },
                onClose: ()=>{
                    
                },
            },
            personRoleInitialSelected: newInvitation.permissions,
            personRoleSelectConfig: {
                controlId: 'personRole' + this.invitationRows.length,
                labelProperty: 'text',
                labelDisplayField: 'text',
                valueKeyField: 'value',
                orderByFields: ['text'],
                orderByDirections: ['asc'],
                placeholder: 'Select Permissions',
                virtualScroll: false,
                onChange: (personRole:any)=>{
                    invitationRow.invitation.permissions = personRole;
                    if(this.isChanged(invitationRow.invitation)){
                        this.adminForm.form.markAsDirty();
                    }
                },
                onAdd: (personRole:any)=>{},
                onOpen: ()=>{
                    
                },
                onClose: ()=>{
                    
                },
            }
        };
        this.invitationRows.push(invitationRow);
    }
    

    private buildUserRows(userData:any):void {
        let userRows = [];
        this._.forEach(userData, (user:any) => {
             // role and permissions were not defined right on this screen. UI shows Role for personType and Permissions for personRole
            user.role = this._.find(this.personTypes, {value: user.role});
            user.permissions = this._.find(this.personRoles, {value: user.permissions});
            user.status = this._.find(this.personRoleStatuses, {value: user.status});  

            user.lastActivity		= this._.isNull(user.lastActivity) ? null : user.lastActivity;
            user.originalStatus		= user.status;
            user.originalPermissions	= user.permissions;
            user.originalRole		= user.role;

            user.markedForRemoval = false;

            let userRow: UserRow = {
                user: user,
                personTypeInitialSelected: user.role,
                personTypeSelectConfig: {
                    controlId: 'personType' + user.personId,
                    labelProperty: 'text',
                    labelDisplayField: 'text',
                    valueKeyField: 'value',
                    orderByFields: ['text'],
                    orderByDirections: ['asc'],
                    placeholder: 'Select Role',
                    virtualScroll: false,
                    onChange: (personType:any)=>{
                       user.role = personType;
                       if(this.isChanged(user)){
                         this.adminForm.form.markAsDirty();
                       }
                    },
                    onAdd: (personType:any)=>{},
                    onOpen: ()=>{
                        
                    },
                    onClose: ()=>{
                        
                    },
                },
                personRoleInitialSelected: user.permissions,
                personRoleSelectConfig: {
                    controlId: 'personRole' + user.personId,
                    labelProperty: 'text',
                    labelDisplayField: 'text',
                    valueKeyField: 'value',
                    orderByFields: ['text'],
                    orderByDirections: ['asc'],
                    placeholder: 'Select Permissions',
                    virtualScroll: false,
                    onChange: (personRole:any)=>{
                        user.permissions = personRole;
                        if(this.isChanged(user)){
                            this.adminForm.form.markAsDirty();
                        }
                    },
                    onAdd: (personRole:any)=>{},
                    onOpen: ()=>{
                        
                    },
                    onClose: ()=>{
                        
                    },
                },
                personStatusInitialSelected: user.status,
                personStatusSelectConfig:{
                    controlId:'personStatus'+user.personId,
                    labelProperty:'text',
                    labelDisplayField:'text',
                    valueKeyField:'value',
                    orderByFields:['text'],
                    orderByDirections:['asc'],
                    placeholder:'Select Status',
                    virtualScroll:false,
                    onChange:(personStatus:any)=>{
                        user.status = personStatus;
                        if(this.isChanged(user)){
                            this.adminForm.form.markAsDirty();
                        }
                    },
                    onAdd:(personStatus:any)=>{},
                    onOpen: ()=>{
                        
                    },
                    onClose: ()=>{
                        
                    },
                }
            };
            userRows.push(userRow);
        });
       this.userRows = userRows;
    }

    private refresh() {
        if (!this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission','USER_MANAGEMENT_READ'))) {
            return this.MSF.loadPage('Login');
        }
        return new Promise<void>((resolve) => {
            var currentFarm = this.MSF.getActiveFarm();

            if (!currentFarm) {
                resolve();
            }

            // make sure we are viewing the user list view
            this.invitingUsers = false;

            this.perfMetricSvc.startTiming('Page:UserManagementPageData:Request');
            this.api.getUsersByFarmId(currentFarm.farmId, this.performanceContext, (err, data) => {
                this.perfMetricSvc.endTiming("page",'Page:UserManagementPageData:Request', this.performanceContext);
                this.perfMetricSvc.startTiming('Page:UserManagement:Build');
            this.loading = false;

                if (err) {
                    this.log.error(this.MSF.notify.danger('unable to get persons for farm: ' + err));
                    this.userRows = [];
                    this.perfMetricSvc.endTiming("page",'Page:UserManagement:Build', this.performanceContext);
                    resolve();
                }
                this.zone.run(() => {
                    // -----------
                    var personKey	= this.MSF.cookies.user.PersonKey;
                    var herdKey		= this.MSF.activeHerd.herdKey;

                    if (!herdKey) {
                        herdKey		= this._.get(this.MSF,"cookies.state.activeFarm.herds[0].herdKey");
                    }

                    if (personKey && herdKey) {
                        this.pageTracker.trackPageView(personKey, herdKey, '(User Management Tab)');	// no need to pass a callback because this is fire and forget
                    }
                    // -----------
                    this.buildUserRows(data);
                });
                this.perfMetricSvc.endTiming("page",'Page:UserManagement:Build', this.performanceContext);
        
            });
        });
    }

    private  confirmInvitationCancellation() {
       this.invitingUsers = false;

        if (this.anyMainRowsEdited()) {
            this.adminForm.form.markAsDirty();
        } else {
            this.adminForm.form.markAsPristine();
        }
    }

    private routeChange(state) {
        var formIsPristine = _.get(event,'currentScope.farmAdminUserManagmentCtrl.adminForm.$pristine');
        if (this.adminForm && this.adminForm.pristine) {
            return;
        }

        var next = state.to();
        var nextParams = state.params('to');
        var event = state.event;

        this.MSF.confirm('unsavedChanges', () => {
            this.deregTransitionOnStart();
            this.MSF.loadPage(next.name,nextParams);
        });

        return  false;
    }

    onContainerScroll() {
        // Close all open dropdowns when scrolling
        this.dropdowns.forEach(dropdown => {
        dropdown.closeDropdown();
        });
    }

    canUpdate() {
        return this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission','USER_MANAGEMENT_UPDATE'));
    };

    invitationRowTrackFn(index:number, invitationRow:InvitationRow) {
        return invitationRow.id;
    }
        


    invite() {
        this.buildInvitationRows();
        this.invitingUsers	= true;
        this.adminForm.form.markAsPristine();
    };

    resendInvitation(existingUser:any, sendToSuperAdmin:boolean=false):void {
        let invitation = this.newInvitation();
        _.set(invitation, 'firstName', existingUser.firstName);
        _.set(invitation, 'lastName', existingUser.lastName);
        _.set(invitation, 'email', existingUser.email);
        _.set(invitation, 'role', existingUser.role.value);
        _.set(invitation, 'permissions', existingUser.permissions.value);
        _.set(invitation, 'status', existingUser.status.value);
        invitation = _.omit(invitation, ['validation']);

        var superAdminEmail= '';
      
        if(sendToSuperAdmin && this.isSuperAdmin){
            superAdminEmail = _.get(this.MSF,"cookies.user.Email");
        }

        this.api.inviteUsersToFarm(this.MSF.getActiveFarm(), [invitation], sendToSuperAdmin, superAdminEmail, (err, data) => {
          if (err) {
                return this.log.error(this.MSF.notify.danger('unable to re-invite users: ' + err));
            }
             this.zone.run(() => {
                this.MSF.notify.success('Invitation has been sent');
            });
        });
    }

    cancelInvitations() {
    
        if (this.adminForm.form.pristine) {
            return this.confirmInvitationCancellation();
        }

        this.MSF.confirm('unsavedChanges', ()=> {
            this.confirmInvitationCancellation();
        });
    };

    addUser() {
        this.buildInvitationRow();
    };

    saveInvitations() {
        // drop any empty rows and re-map the data for the API call
        let idsAndInvitations = this._.cloneDeep(
                                            this._.map(this.invitationRows,(invRow)=>{ 
                                                return {
                                                    id:invRow.id ,
                                                    invitation:invRow.invitation
                                                };
                                            })
                                        );
        let validIdsAndInvitations = this._.reject(idsAndInvitations, (idAndInvitation) => {
                                            return	this._.isEmpty(idAndInvitation.invitation.firstName)	&&
                                                    this._.isEmpty(idAndInvitation.invitation.lastName)	    &&
                                                    this._.isEmpty(idAndInvitation.invitation.email)		
                                        });
        validIdsAndInvitations = this._.map(validIdsAndInvitations ,(idAndInvitation) => {
                                    this._.set(idAndInvitation, 'invitation.permissions', idAndInvitation.invitation.permissions.value);
                                    this._.set(idAndInvitation, 'invitation.role', idAndInvitation.invitation.role.value);
                                    return idAndInvitation;
                                });
                                
        // validate remaining
        this._.forEach(validIdsAndInvitations, (idAndInvitation) => {
            let invitationRowValidation	= _.get(this._.find(this.invitationRows, {id: idAndInvitation.id}),'invitation.validation', {}) as InvitationValidation;
            let validRowInvitation	= idAndInvitation.invitation as Invitation;
            invitationRowValidation.firstName = validRowInvitation.validation.firstName     = !this._.isEmpty(validRowInvitation.firstName);
            invitationRowValidation.lastName = validRowInvitation.validation.lastName		 = !this._.isEmpty(validRowInvitation.lastName);
            invitationRowValidation.email = validRowInvitation.validation.email			 = !!validRowInvitation.email.match(/^[^@\s]+@[^@\s]+\.[^@\s\.]+$/);
            invitationRowValidation.role = validRowInvitation.validation.role			     = !this._.isNull(validRowInvitation.role);
            invitationRowValidation.permissions	= validRowInvitation.validation.permissions = !this._.isNull(validRowInvitation.permissions);
        });

        if (this._.any(validIdsAndInvitations,(idAndInvitation) => {
            return this._.includes(this._.values(idAndInvitation.invitation.validation), false);
        })) {
            return this.log.error('Validation errors found!');
        }
        // drop Id for API call
        const validInvitations = this._.map(validIdsAndInvitations, (idAndInvitation) => {
            return idAndInvitation.invitation;
        });

        this.loading = true;
        this.api.inviteUsersToFarm(this.MSF.getActiveFarm(), validInvitations,false,"", (err, data) => {
            this.loading = false;

            if (err) {
                return this.log.error(this.MSF.notify.danger('unable to invite users: ' + err));
            }
            this.zone.run(() => {
                this.MSF.notify.success('Invitations have been sent');
                this.adminForm.form.markAsPristine();
                this.refresh();
            });
        });
    };

    saveMain() {
        // get re-mapped user data for update
        const users = this._.map(this._.cloneDeep(this._.pluck(this.userRows,"user")), (user) => {
                        this._.set(user, 'status', user.status.value);
                        this._.set(user, 'permissions', user.permissions.value);
                        this._.set(user, 'role', user.role.value);
                        return user;     
                    });
        
        var updates = this._.map(this._.filter(users, this.isChanged), (user) => {
            return {
                farmId:		user.farmId,
                personId:	user.personId,
                roleId:		user.permissions,
                status:		user.status,
                personType:	user.role
            };
        });

        if (!this._.filter(users, {permissions: 3}).length) {
            this.MSF.notify.danger('There must be at least one Farm admin.');

            return false;
        }

        this.loading = true;
        this.api.updatePersonRoles(updates, (err, result) => {
            this.loading = false;

            if (err || this._.isEmpty(result)) {
                return this.log.error(this.MSF.notify.danger('Unable to updated users: ' + err));
            }
            this.zone.run(() => {
                this.MSF.notify.success('Users updated');
                this.adminForm.form.markAsPristine();
                this.refresh();
            });
        });
    };

    cancelMain() {
        this._.forEach(this.userRows, (userRow) => {
            userRow.user.status			= {...userRow.user.originalStatus};
            userRow.personStatusInitialSelected	= {...userRow.user.originalStatus};
            userRow.user.permissions	= {...userRow.user.originalPermissions};
            userRow.personRoleInitialSelected	= {...userRow.user.originalPermissions};
            userRow.user.role			= {...userRow.user.originalRole};
            userRow.personTypeInitialSelected	= {...userRow.user.originalRole};
        });
        this.adminForm.form.markAsPristine();
    };

    
    isChanged(user) {
        const originalStatus = this._.get(user, 'originalStatus.value', null);
        const originalPermissions = this._.get(user, 'originalPermissions.value', null);
        const originalRole = this._.get(user, 'originalRole.value', null);
        const currentStatus = this._.get(user, 'status.value', null);
        const currentPermissions = this._.get(user, 'permissions.value', null);
        const currentRole = this._.get(user, 'role.value', null);
        return originalStatus		!== currentStatus			||
               originalPermissions	!== currentPermissions	||
               originalRole			!== currentRole;
    };

    anyMainRowsEdited() {
        return this._.any(this._.pluck(this.userRows,"user"), this.isChanged);
    };

    getNumberOfAdmins(){
        return this._.filter(this.userRows, (userRow) => {
            return userRow.user.permissions.value === 3;
        }).length;
    }
    toggleModal(modalId) {                
        var modal = $('#' + modalId);
        if (this._.isUndefined(modal[0]) || !modal[0]) return;

        if (modal.is(':visible')) {
            modal.css("display", "none");
        } else {
            modal.css("display", "block");
        }
    };
    onDeleteUsersChange() {
       this.removeFromAllFarms = this.deleteUsers;
    }

    onRemoveUsersFromFarm() {
        if(this._.isEqual(this.usersToRemove.length, this.userRows.length)) {
            this.MSF.notify.danger('Cannot remove users from farm. Farms require at least one admin user.');
        }else{
            if(this._.isEqual(this.getNumberOfAdmins(), this._.filter(this.usersToRemove, (user) => {return user.permissions.value === 3;}).length)) {
                this.MSF.notify.danger('Cannot remove users from farm. Farms require at least one admin user.');
            }else{
                this.toggleModal('removeUsersFromFarmModal');
            }
        }
    };

    cancelRemoveUsersFromFarm() {
        this.zone.run(() => {
            this.usersToRemove = [];
            this.removeFromAllFarms = false;
            this.deleteUsers = false;
            this._.forEach(this.userRows, (userRow) => {
                userRow.user.markedForRemoval = false;
            });
            // grab all of the removeUser-* checkboxes and reset their checked status
            $('input[id^="removeUser-"]').prop('checked', false);
        });

        this.toggleModal('removeUsersFromFarmModal');
    }

    markUserForRemoval(user) {
        if (this._.isUndefined(this._.find(this.usersToRemove, { personId: this._.get(user, 'personId') }))) {
            user.markedForRemoval = true;
            this.usersToRemove.push(user);
        } else {
            user.markedForRemoval = false;
            this._.remove(this.usersToRemove, (u) => _.isEqual(_.get(u, 'personId'), _.get(user, 'personId')));
        }
    }

    removeUsersFromFarm() {
        var data = {
            personIdsJSON: JSON.stringify(this._.map(this.usersToRemove, (user) => { return { personId: this._.get(user, 'personId') }; })),
            initialHerdId: this._.get(this.currentHerd, 'herdId'),
            removeFromAllFarms: this._.isEqual(this.deleteUsers, true) ? true : this.removeFromAllFarms,
            deleteUsers: this.deleteUsers
        };
        this.api.removeUsersFromFarms(data, (err, result) => {
            if (err) {
                return this.log.error(this.MSF.notify.danger('Unable to remove users'));
            }
            this.zone.run(() => {
              
                this.MSF.notify.success('Users removed');
                // if the current user removed themselves from the farm we need to notify the farm select of the change
                if(!this._.isUndefined(this._.find(this.usersToRemove, {personId: this._.get(this.MSF,"cookies.user.PersonId")}))) {
                    if(this.removeFromAllFarms || this.deleteUsers || this._.get(this.MSF.getAvailableFarms(), 'length', 0) === 1) {
                        this.MSF.logoutWithMessage("danger",'You have been removed from the farm and all herds. Please contact your local Parnell Territory Manager with any questions.');
                    }else {

                        this.broadCastService.sendFarmRemovedUserMsg(this.currentFarm);
                    }
                }else{
                    this.refresh();
                }

                this.removeFromAllFarms = false;
                this.deleteUsers = false;
                this.usersToRemove = [];
                this.toggleModal('removeUsersFromFarmModal');
                    
                
            });
        });
    }

    
    ngOnDestroy() {
        if (this.deregTransitionOnStart) {
            this.deregTransitionOnStart();
        }
        if (this.deregCurrentFarmSubscription) {
            this.deregCurrentFarmSubscription.unsubscribe();
        }
        if(this.deregCurrentHerdSubscription) {
            this.deregCurrentHerdSubscription.unsubscribe();
        }

        this.performanceContext = null;
    }

    ngOnInit() {
        this.MSF.ready(()=>{
            this.perfMetricSvc.startTiming('Page:UserManagement:Render');
            this.deregTransitionOnStart = this.$transitions.onStart({}, this.routeChange.bind(this));

            this.currentFarm = this.MSF.getActiveFarm();
            this.farmName = this._.get(this.currentFarm, 'name', '');

            this.currentHerd = this.MSF.getActiveHerd();

            this.personRoles = this._.reject(this.mySynchEnumSvc.getMySynchEnumerationItems('Role'), function rejectNames(i) {
                return _.includes(['SUPER_ADMIN', 'TERRITORY_MANAGER','PARNELL_VIEWER','DEMO_USER'], i.name);
            });
            this.personTypes			= this._.values(this.mySynchEnumSvc.getMySynchEnumerationItems("PersonType"));
            this.personRoleStatuses	= this._.reject(this._.values(this.mySynchEnumSvc.getMySynchEnumerationItems("PersonRoleStatus")), {name: 'PENDING'});
            this.pendingValue	= this._.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'value');
            this.pendingText	= this._.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'text');

            this.confirmAbilityToDeleteUsers();
          
         this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.currentHerd,'herdId',null));
          this.refresh().then(() => {
            this.perfMetricSvc.markPageReady('Page:UserManagement:Render', this.performanceContext);
          });

            this.deregCurrentFarmSubscription = this.mysynchDataStore.currentActiveFarm
            .subscribe((currentFarm:Farm) => {
                if(!this.MSF.isNullish(currentFarm) && !this.loading){
                    this.perfMetricSvc.startTiming('Page:UserManagementOnFarmChange:Render');
                    this.currentFarm = currentFarm;
                    this.farmName = this._.get(this.currentFarm, 'name', '');
                    this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.currentFarm,'herds[0].herdId',null));
                    this.refresh().then(() => {
                        this.perfMetricSvc.markPageReady('Page:UserManagementOnFarmChange:Render', this.performanceContext);
                    });
                }
            });

            this.deregCurrentHerdSubscription = this.mysynchDataStore.currentActiveHerd
            .subscribe((currentHerd:Herd) => {
                if(currentHerd){
                    this.currentHerd = currentHerd;
                }
            });

        });
    }

}